import styled from 'styled-components';

export const ContentWrapper = styled.div`
    margin: 0 auto;
    max-width: 458px;
`;

export const MultilineTextWrppaer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 420px;
`;

// skeletons

const SkeletonContainer = styled.div`
    margin: 0 auto;
    max-width: 460px;
`;

const SkeletonText = styled.div`
    margin: 40px 0 24px;
    text-align: center;
`;

const SkeletonLabel = styled.div`
    margin-bottom: 10px;
`;

const SkeletonMessage = styled.div`
    margin-bottom: 16px;
    width: 100%;
`;

export const ConversationDetailsSkeleton = {
    Container: SkeletonContainer,
    Label: SkeletonLabel,
    Message: SkeletonMessage,
    Text: SkeletonText,
};
